"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LessonType = void 0;
var LessonType;
(function (LessonType) {
    LessonType["SYSTEM"] = "system";
    LessonType["CUSTOM"] = "custom";
})(LessonType = exports.LessonType || (exports.LessonType = {}));
